/**
 * Filtros aplicados na listagem de módulos de aula.
 *
 * Espelha os query params do endpoint `GET /api/v1/classroomdiscipline/class-modules`:
 * `Description`, `CompanyId`, `ClassStudentId`, `DateStart`, `DateFinish` e `PageNumber`.
 * Os campos `*Label` guardam o rótulo exibido nos autocompletes (não vão para a API).
 * As datas usam o formato ISO `YYYY-MM-DD` emitido pelo `DatePicker`.
 */
export interface ClassModuleFilters {
  /** Busca parcial por descrição do módulo. */
  readonly description: string;
  /** Identificador da empresa selecionada (`CompanyId`), ou `null`. */
  readonly companyId: number | null;
  /** Rótulo da empresa selecionada (exibição no autocomplete). */
  readonly companyLabel: string;
  /** Identificador da turma selecionada (`ClassStudentId`), ou `null`. */
  readonly classStudentId: number | null;
  /** Rótulo da turma selecionada (exibição no autocomplete). */
  readonly classStudentLabel: string;
  /** Data inicial (ISO `YYYY-MM-DD`) para o filtro `DateStart`. */
  readonly dateStart: string;
  /** Data final (ISO `YYYY-MM-DD`) para o filtro `DateFinish`. */
  readonly dateFinish: string;
  /** Página atual (1-indexed) para `PageNumber`. */
  readonly page: number;
}

/** Estado inicial (sem filtros, primeira página). */
export const INITIAL_CLASS_MODULE_FILTERS: ClassModuleFilters = {
  description: '',
  companyId: null,
  companyLabel: '',
  classStudentId: null,
  classStudentLabel: '',
  dateStart: '',
  dateFinish: '',
  page: 1,
};
